<template>
    <div>
        <div
            v-for="document in documents"
            :key="document">
            <a
                target="_blank"
                :href="document.url"
                class="text-primary-500 hover:text-primary-600"
                rel="noopener noreferrer">
                {{ document.originalName }}
            </a>
        </div>
    </div>
</template>
<script lang="ts" setup>
const props = defineProps({
  params: Object
})

const { params } = toRefs(props)

const documents = computed(() => {
  return params?.value?.data?.documents || []
})
</script>
